export default "__VITE_ASSET__DqdeCoyX__"